module.exports = __webpack_public_path__ + "img/primary-sub-1.424e9a5d.jpg";